import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-flavour',
  templateUrl: './flavour.component.html',
  styleUrls: ['./flavour.component.css']
})
export class FlavourComponent implements OnInit {

  model = {
    'table_name': 'flavour', 'flavour_id': '0', 'main_item_id': '0', 'flavour_name': '',
    'flavour_name_en': '', 'flavour_price': '', 'comment': ''
  };

  search_obj = {
    'placeholder': 'اسم الصنف', 'class_name': 'searchField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'main_item_id',
      'field_list': ['main_item_name', 'main_item_name_en']
    }]
  };  
  // main_item = [];

  Main_Item_Placeholder;
  Success_Msg; Error_Msg; Flavour_Name_Msg;
  Price_Msg; Main_Item_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<FlavourComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Main_Item_Placeholder').subscribe((res: string) => {
      this.Main_Item_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Main_Item_Placeholder;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Flavour_Name_Msg').subscribe((res: string) => {
      this.Flavour_Name_Msg = res;
    });

    translate.get('Price_Msg').subscribe((res: string) => {
      this.Price_Msg = res;
    });

    translate.get('Main_Item_Msg').subscribe((res: string) => {
      this.Main_Item_Msg = res;
    });

  }


  ngOnInit() {

    if (this.dialog_data != null) {
      this.model = this.dialog_data;

      // get the main item name
      let query = "SELECT * FROM `main_item` WHERE `status` = '1' AND `main_item_id` = '" + this.model.main_item_id + "'";
      let obj = { cmd: 'getList', query: query };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          let main_item = data.data['list'];
          (document.getElementById('search_value_0') as HTMLInputElement).value = main_item[0].main_item_name + 
            '-' + main_item[0].main_item_name_en;
        });
    }
      
    // let query = "SELECT * FROM `main_item` WHERE `status` = '1'";
    // let obj = { cmd: 'getList', query: query };
    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.main_item = data.data['list'];
    //   });
  }

  onChangeSearch = function (search_result: object) {
    this.model['main_item_id'] = search_result['no'];
  }

  add() {
    if (this.model['flavour_name'] == '')
      alert(this.Flavour_Name_Msg);
    else if (this.model['flavour_price'] == '')
      alert(this.Price_Msg);
    else if (this.model['main_item_id'] == '0')
      alert(this.Main_Item_Msg);

    else {
      let values = [];
      values.push(this.model);
      //console.log(values);
      let obj;
      if (this.model['flavour_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'flavour_id': this.model['flavour_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          //console.log(data);
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            // this.dialog_data = {
            //   'status': data.status['type']
            // };
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }

  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }


}
